
import { defineComponent } from 'vue';
import { QrcodeStream } from 'vue-qrcode-reader';
import { DetectedBarcode } from 'barcode-detector';
import SvgFlashlight from './Icons/SvgFlashlight.vue';
import QRScannerCapabilities from '@/types/QRScannerCapabilities';

export default defineComponent({
    name: 'FbxQrScanner',
    components: { QrcodeStream, SvgFlashlight },
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        paused: {
            type: Boolean,
            default: false,
        },
        instructionText: {
            type: String,
            default: 'Find code to scan',
        },
    },
    emits: ['scanned', 'scanError', 'scannerReady'],
    data: (): {
        flashlightActive: boolean;
        flashlightSupported: boolean;
        scannedId: string;
    } => {
        return {
            flashlightActive: false,
            flashlightSupported: false,
            scannedId: '',
        };
    },
    computed: {
        flashlightColor() {
            return this.flashlightActive ? 'yellow' : 'white';
        },
    },
    watch: {},
    methods: {
        async onDetect([detectedCode]: [DetectedBarcode]): Promise<void> {
            const qrUrl = new URL(detectedCode.rawValue);
            this.$emit('scanned', qrUrl);
        },
        async onCameraOn(capabilities: QRScannerCapabilities): Promise<void> {
            this.flashlightSupported = capabilities.torch;
            this.$emit('scannerReady', true);
        },
        onError(error: Error): void {
            if (error.name === 'NotAllowedError') {
                console.warn('user denied camera access permission');
            } else if (error.name === 'NotFoundError') {
                console.warn('no suitable camera device installed');
            } else if (error.name === 'NotSupportedError') {
                console.warn('page is not served over HTTPS (or localhost)');
            } else if (error.name === 'NotReadableError') {
                console.warn('camera may already be in use');
            } else if (error.name === 'OverconstrainedError') {
                console.warn(
                    'did you request the front camera although there is none?'
                );
            } else if (error.name === 'StreamApiNotSupportedError') {
                console.warn('browser does not support StreamApi');
            } else {
                console.error(error.message);
            }
            this.$emit('scanError');
        },
    },
});
